// queries/useGetUserModelsNames.ts
"use client";
import { GET_USER_MODELS_NAMES } from "api";
import { fetch } from "libs";
import { useQuery } from "@tanstack/react-query";

const fetchUserTransactions = async () => {
  return fetch(`${GET_USER_MODELS_NAMES}`);
};

export const useGetUserModelsNames = () => {
  // @ts-ignore
  return useQuery({
    queryKey: ["userModelsNames"],
    queryFn: () => fetchUserTransactions(),
  });
};

export default useGetUserModelsNames;
